import React from 'react';

const NavLinksLeft = ({ setIsMenuOpen }) => {
  return (
    <>
      <li>
        <a
          href="/#featured"
          aria-label="Our tours"
          title="Our tours"
          className="nav-link "
          onClick={() => setIsMenuOpen(false)}
        >
          Tours
        </a>
      </li>
      <li>
        <a
          href="/#tips"
          aria-label="Travel Tips"
          title="Travel Tips"
          className="nav-link"
          onClick={() => setIsMenuOpen(false)}
        >
          Tips
        </a>
      </li>
      <li>
        <a
          href="/#services"
          aria-label="Our services"
          title="Our services"
          className="nav-link"
          onClick={() => setIsMenuOpen(false)}
        >
          Services
        </a>
      </li>
    </>
  );
};

export default NavLinksLeft;
